export default "__VITE_ASSET__9M$8Mnvv__"